import { capitalize } from "utils/capitalize";

export const humanize = (value: string) =>
  value.split("_").map(capitalize).join(" ");
